import { legacyPlugins } from "/Users/szymon-mini-one/worktrees/landing-batch250-20261104/node_modules/.pnpm/@unhead+vue@3.4.3_@oxc-project+types@0.155.0_esbuild@0.28.1_lightningcss@1.33.0_oxc-par_3e66cb616487dbad756add17c1d52b09/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}